import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { AuthService, encryptStorage } from 'src/app/auth/auth.service';
import { Orders } from 'src/app/models/orders';
import { emptyFields, MerchantOrderStatus, MerchantOrderStatusOptions, OrderStatus,OrderStatusOptions } from 'src/app/utilities/common-file';
import { CommonService } from 'src/app/utilities/common-service';
import { Messages } from 'src/app/utilities/message';
import { OrdersService } from '../../orders.service';

@Component({
  selector: 'app-edit-orders',
  templateUrl: './edit-orders.component.html'
})
export class EditOrdersComponent implements OnInit {

  @Input() selectedOrders: any;
  @Input() buttonLoadingForUpdate = false;
  @Output() onSavedUser = new EventEmitter<any>();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onEditOrder = new EventEmitter<any>();
  orderForm: UntypedFormGroup;
  orderStatus = MerchantOrderStatus;
  orderStatusOptions = MerchantOrderStatusOptions;
  // For App Code
  showAppCodeFilter = false;
  appCodeOptions = [];
  selectedOrder: any;
  data: any;
  currencySymbol='';
  emptyField = emptyFields;



  constructor(
    private fb: UntypedFormBuilder,
    private orderService: OrdersService,
    private notification: NzNotificationService,
    private drawerRef: NzDrawerRef<string>,
    private authService: AuthService,
    private modal: NzModalService,
    private commonService:CommonService
  ) {
    this.orderForm = this.fb.group({
      appCode: [''],
      merchantLocationId: [''],
      orderStatus: ['']




    });
  }

  ngOnInit() {
  this.data = this.selectedOrders;

  // this.selectedOrder = this.selectedOrders;
  if (this.selectedOrders) {
    this.orderForm.patchValue(this.selectedOrders);
  }
  this.currencySymbol = encryptStorage.getItem('currencySymbol');


  }
  getAppCodeDetails() {
    // this.appCodeOptions = this.authService.getAllAppCode(); // To get appcode options based on instance
   }
  editOrder() {
    if (this.orderForm.valid) {
      this.buttonLoadingForUpdate = true;
      const value = {
        appCode: this.orderForm.value.appCode,
        merchantLocationId: this.orderForm.value.merchantLocationId,
        orderStatus: this.orderForm.value.orderStatus
      };
      this.orderService.editMerchantOrder(this.selectedOrders.id, value).subscribe((res) => {
        this.notification.success(Messages.updated, '', {
          nzKey: 'key'
        });
        this.onEditOrder.emit(res as Orders);
        this.close();
        // this.refresh();
        // Emit response to edit-terminal drawer component
      }, error => {
        this.buttonLoadingForUpdate = false;
      });

    } else {
      this.buttonLoadingForUpdate = false;
      // tslint:disable-next-line: forin
      for (const i in this.orderForm.controls) {
        this.orderForm.controls[i].markAsDirty();
        this.orderForm.controls[i].updateValueAndValidity();
        this.notification.error(Messages.error, '', {
          nzKey: 'key'
        });
      }
    }
  } 
    // For Delete confirmation popup
    showDeleteConfirm() {
      this.modal.confirm({
        nzTitle: 'Are you sure you want to delete this Order?',
        nzOkText: 'Yes',
        nzOkType: 'danger',
        nzOnOk: () => this.deleteTerminal(this.selectedOrders),
        nzCancelText: 'No',
        nzOnCancel: () => console.log('Cancel')
      });
    }
    // Delete Terminal API request
    deleteTerminal(data) {
      this.orderService.deleteMerchantOrder(data.id).subscribe(res => {
        this.notification.success(Messages.deleted, '', {
          nzKey: 'key'
        });
        this.onEditOrder.emit(res as Orders);
        this.close();
        // this.refresh(); // Emit response to edit-terminal drawer component
      });
    }
    // To Close drawer
    close(): void {
      this.drawerRef.close();
    }
    showDisabled(status) {
      if (status === this.orderForm.value.orderStatus) {
        return true;
      } else {
        return null;
      }
    }

    getStatus(status) {
      return this.commonService.getOrderStatus(status);
    }
    // For User Status Tag color
    getStatusColor(status) {
      return this.commonService.getOrderStatusColor(status);
    }
    getDeliveryMethod(row){
      return this.commonService.getDeliveryMethod(row);
    }
    getDeliveryAddress(row){
      let data = JSON.parse(row)
      return data.replace(/[{}]/g, '');
    }

}

